import * as signalR from '@microsoft/signalr';
import { acquireAccessToken } from '../../services/api';

// The hub is served by the same .NET app as the REST API, which runs under the "/api" path base
// (UsePathBase("/api") in Program.cs; in prod the API is the "/api" sub-application). So the hub
// lives at "<API base>/hubs/calls" — keep the "/api", don't strip it, or prod hits the React
// root site instead of the hub. Works for dev (http://localhost:4001/api) and prod (relative /api).
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4001/api';
const HUB_URL = API_URL.replace(/\/$/, '') + '/hubs/calls';

// A SignalR connection to the Communication calls hub. WebSockets can't send an Authorization
// header, so the access token rides the query string via accessTokenFactory (the server reads it
// for the hub path). Auto-reconnect covers transient drops; the list's poll is the backstop.
export const buildCallsConnection = (): signalR.HubConnection =>
  new signalR.HubConnectionBuilder()
    .withUrl(HUB_URL, { accessTokenFactory: acquireAccessToken })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Warning)
    .build();
